/**
 * @generated SignedSource<<2387dd9c24ec60b5a05c0e3bc228c941>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { outOfStock as hubProductOutOfStockResolverType } from "../../../../client-resolvers";
// Type assertion validating that `hubProductOutOfStockResolverType` resolver is correctly implemented.
// A type error here indicates that the type signature of the resolver module is incorrect.
(hubProductOutOfStockResolverType satisfies (
  rootKey: clientResolversOutOfStockFragment$key,
) => boolean | null | undefined);
export type ProductTrackFragment$data = {
  readonly nodes: ReadonlyArray<{
    readonly id: string;
    readonly outOfStock: boolean | null | undefined;
    readonly priceAmount: number;
    readonly product: {
      readonly brand: {
        readonly id: string;
        readonly organization: {
          readonly id: string;
          readonly name: string;
        };
      };
      readonly category: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly id: string;
      readonly name: string;
    };
    readonly stock: number;
    readonly " $fragmentSpreads": FragmentRefs<"ProductCardFragment">;
  }>;
  readonly " $fragmentType": "ProductTrackFragment";
};
export type ProductTrackFragment$key = {
  readonly " $data"?: ProductTrackFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductTrackFragment">;
};

import {outOfStock as hubProductOutOfStockResolver} from '../../../../client-resolvers';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*:: as any*/),
  (v1/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductTrackFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HubProduct",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stock",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "fragment": {
            "args": null,
            "kind": "FragmentSpread",
            "name": "clientResolversOutOfStockFragment"
          },
          "kind": "RelayResolver",
          "name": "outOfStock",
          "resolverModule": hubProductOutOfStockResolver,
          "path": "nodes.outOfStock"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "product",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Brand",
              "kind": "LinkedField",
              "name": "brand",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organization",
                  "kind": "LinkedField",
                  "name": "organization",
                  "plural": false,
                  "selections": (v2/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Category",
              "kind": "LinkedField",
              "name": "category",
              "plural": false,
              "selections": (v2/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductCardFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HubProductPage",
  "abstractKey": null
};
})();

(node as any).hash = "9e1936d935f5c9993c1703a5c11b4019";

export default node;
